// extracted by mini-css-extract-plugin
export var modalFooter = "_rg-0";